import { HttpClient, HttpHeaders } from '@angular/common/http';

export abstract class BaseFileService {
  SINGLE_FILE_UPLOAD_URL = '';
  MULTIPLE_FILE_UPLOAD_URL = '';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    }),
  };

  protected http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  uploadFile(file, isMultiple: boolean) {
    return this.http.post(
      isMultiple ? this.MULTIPLE_FILE_UPLOAD_URL : this.SINGLE_FILE_UPLOAD_URL,
      file,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }
}
